const STATE_NAMES = [
    { optionText: "Alabama", id: 1 },
    { optionText: "Alaska", id: 2 },
    { optionText: "Arizona", id: 3 },
    { optionText: "Arkansas", id: 4 },
    { optionText: "California", id: 5 },
    { optionText: "Colorado", id: 6 },
    { optionText: "Connecticut", id: 7 },
    { optionText: "Delaware", id: 8 },
    { optionText: "District of Columbia", id: 9 },
    { optionText: "Florida", id: 10 },
    { optionText: "Georgia", id: 11 },
    { optionText: "Hawaii", id: 12 },
    { optionText: "Idaho", id: 13 },
    { optionText: "Illinois", id: 14 },
    { optionText: "Indiana", id: 15 },
    { optionText: "Iowa", id: 16 },
    { optionText: "Kansas", id: 17 },
    { optionText: "Kentucky", id: 18 },
    { optionText: "Louisiana", id: 19 },
    { optionText: "Maine", id: 20 },
    { optionText: "Montana", id: 21 },
    { optionText: "Nebraska", id: 22 },
    { optionText: "Nevada", id: 23 },
    { optionText: "New Hampshire", id: 24 },
    { optionText: "New Jersey", id: 25 },
    { optionText: "New Mexico", id: 26 },
    { optionText: "New York", id: 27 },
    { optionText: "North Carolina", id: 28 },
    { optionText: "North Dakota", id: 29 },
    { optionText: "Ohio", id: 30 },
    { optionText: "Oklahoma", id: 31 },
    { optionText: "Oregon", id: 32 },
    { optionText: "Maryland", id: 33 },
    { optionText: "Massachusetts", id: 34 },
    { optionText: "Michigan", id: 35 },
    { optionText: "Minnesota", id: 36 },
    { optionText: "Mississippi", id: 37 },
    { optionText: "Missouri", id: 38 },
    { optionText: "Pennsylvania", id: 39 },
    { optionText: "Rhode Island", id: 40 },
    { optionText: "South Carolina", id: 41 },
    { optionText: "South Dakota", id: 42 },
    { optionText: "Tennessee", id: 43 },
    { optionText: "Texas", id: 44 },
    { optionText: "Utah", id: 45 },
    { optionText: "Vermont", id: 46 },
    { optionText: "Virginia", id: 47 },
    { optionText: "Washington", id: 48 },
    { optionText: "West Virginia", id: 49 },
    { optionText: "Wisconsin", id: 50 },
    { optionText: "Wyoming", id: 51 },
    { optionText: "Puerto Rico", id: 52 },
    { optionText: "American Samoa", id: 63 },
    { optionText: "Guam", id: 64 },
    { optionText: "Northern Mariana Islands", id: 65 },
    { optionText: "Virgin Islands", id: 66 },
    { optionText: "Alberta", id: 53 },
    { optionText: "British Columbia", id: 54 },
    { optionText: "Manitoba", id: 55 },
    { optionText: "New Brunswick", id: 56 },
    { optionText: "Newfoundland and Labrador", id: 57 },
    { optionText: "Nova Scotia", id: 58 },
    { optionText: "Ontario", id: 59 },
    { optionText: "Prince Edward Island", id: 60 },
    { optionText: "Quebec", id: 61 },
    { optionText: "Saskatchewan", id: 62 },
].sort((a, b) => (a.optionText > b.optionText ? 1 : -1));

const STATE_NAMES_BY_ID = STATE_NAMES.reduce(
    (sum, state) => ({ ...sum, [state.id]: state.optionText }),
    {},
) as Record<number, string>;

const STATE_ABBR_NAMES = [
    { optionText: "AL", id: 1 },
    { optionText: "AK", id: 2 },
    { optionText: "AZ", id: 3 },
    { optionText: "AR", id: 4 },
    { optionText: "CA", id: 5 },
    { optionText: "CO", id: 6 },
    { optionText: "CT", id: 7 },
    { optionText: "DE", id: 8 },
    { optionText: "DC", id: 9 },
    { optionText: "FL", id: 10 },
    { optionText: "GA", id: 11 },
    { optionText: "HI", id: 12 },
    { optionText: "ID", id: 13 },
    { optionText: "IL", id: 14 },
    { optionText: "IN", id: 15 },
    { optionText: "IA", id: 16 },
    { optionText: "KS", id: 17 },
    { optionText: "KY", id: 18 },
    { optionText: "LA", id: 19 },
    { optionText: "ME", id: 20 },
    { optionText: "MT", id: 21 },
    { optionText: "NE", id: 22 },
    { optionText: "NV", id: 23 },
    { optionText: "NH", id: 24 },
    { optionText: "NJ", id: 25 },
    { optionText: "NM", id: 26 },
    { optionText: "NY", id: 27 },
    { optionText: "NC", id: 28 },
    { optionText: "ND", id: 29 },
    { optionText: "OH", id: 30 },
    { optionText: "OK", id: 31 },
    { optionText: "OR", id: 32 },
    { optionText: "MD", id: 33 },
    { optionText: "MA", id: 34 },
    { optionText: "MI", id: 35 },
    { optionText: "MN", id: 36 },
    { optionText: "MS", id: 37 },
    { optionText: "MO", id: 38 },
    { optionText: "PA", id: 39 },
    { optionText: "RI", id: 40 },
    { optionText: "SC", id: 41 },
    { optionText: "SD", id: 42 },
    { optionText: "TN", id: 43 },
    { optionText: "TX", id: 44 },
    { optionText: "UT", id: 45 },
    { optionText: "VT", id: 46 },
    { optionText: "VA", id: 47 },
    { optionText: "WA", id: 48 },
    { optionText: "WV", id: 49 },
    { optionText: "WI", id: 50 },
    { optionText: "WY", id: 51 },
    { optionText: "PR", id: 52 },
    { optionText: "AS", id: 63 },
    { optionText: "GU", id: 64 },
    { optionText: "MP", id: 65 },
    { optionText: "VI", id: 66 },
    { optionText: "AB", id: 53 },
    { optionText: "BC", id: 54 },
    { optionText: "MB", id: 55 },
    { optionText: "NB", id: 56 },
    { optionText: "NL", id: 57 },
    { optionText: "NS", id: 58 },
    { optionText: "ON", id: 59 },
    { optionText: "PE", id: 60 },
    { optionText: "QC", id: 61 },
    { optionText: "SK", id: 62 },
].sort((a, b) => (a.optionText > b.optionText ? 1 : -1));

export const GROUPED_STATE_SELECT_OPTIONS = [
    {
        label: "United States",
        options: STATE_ABBR_NAMES.filter((o) => o.id <= 52).map((o) => ({
            label: `${STATE_NAMES_BY_ID[o.id]} (${o.optionText})`,
            value: o.id,
        })),
    },
    {
        label: "Canada",
        options: STATE_ABBR_NAMES.filter((o) => o.id > 52).map((o) => ({
            label: `${STATE_NAMES_BY_ID[o.id]} (${o.optionText})`,
            value: o.id,
        })),
    },
];

export const getStateProvinceSelectOption = (id: number) => {
    const state = STATE_ABBR_NAMES.find((o) => o.id === id);
    if (!state) {
        return undefined;
    } else {
        return { label: `${STATE_NAMES_BY_ID[state.id]} (${state.optionText})`, value: state.id };
    }
};

export const STATE_OPTIONS = [
    { label: "", value: undefined },
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "District of Columbia", value: "DC" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" },
    { label: "Puerto Rico", value: "PR" },
    { label: "American Samoa", value: "AS" },
    { label: "Guam", value: "GU" },
    { label: "Northern Mariana Islands", value: "MP" },
    { label: "Virgin Islands", value: "VI" },
    { label: "Alberta", value: "AB" },
    { label: "British Columbia", value: "BC" },
    { label: "Manitoba", value: "MB" },
    { label: "New Brunswick", value: "NB" },
    { label: "Newfoundland and Labrador", value: "NL" },
    { label: "Nova Scotia", value: "NS" },
    { label: "Ontario", value: "ON" },
    { label: "Prince Edward Island", value: "PE" },
    { label: "Quebec", value: "QC" },
    { label: "Saskatchewan", value: "SK" },
];

export const STATE_SHORT_OPTIONS = [
    { label: "AL", value: "AL" },
    { label: "AK", value: "AK" },
    { label: "AZ", value: "AZ" },
    { label: "AR", value: "AR" },
    { label: "CA", value: "CA" },
    { label: "CO", value: "CO" },
    { label: "CT", value: "CT" },
    { label: "DE", value: "DE" },
    { label: "DC", value: "DC" },
    { label: "FL", value: "FL" },
    { label: "GA", value: "GA" },
    { label: "HI", value: "HI" },
    { label: "ID", value: "ID" },
    { label: "IL", value: "IL" },
    { label: "IN", value: "IN" },
    { label: "IA", value: "IA" },
    { label: "KS", value: "KS" },
    { label: "KY", value: "KY" },
    { label: "LA", value: "LA" },
    { label: "ME", value: "ME" },
    { label: "MT", value: "MT" },
    { label: "NE", value: "NE" },
    { label: "NV", value: "NV" },
    { label: "NH", value: "NH" },
    { label: "NJ", value: "NJ" },
    { label: "NM", value: "NM" },
    { label: "NY", value: "NY" },
    { label: "NC", value: "NC" },
    { label: "ND", value: "ND" },
    { label: "OH", value: "OH" },
    { label: "OK", value: "OK" },
    { label: "OR", value: "OR" },
    { label: "MD", value: "MD" },
    { label: "MA", value: "MA" },
    { label: "MI", value: "MI" },
    { label: "MN", value: "MN" },
    { label: "MS", value: "MS" },
    { label: "MO", value: "MO" },
    { label: "PA", value: "PA" },
    { label: "RI", value: "RI" },
    { label: "SC", value: "SC" },
    { label: "SD", value: "SD" },
    { label: "TN", value: "TN" },
    { label: "TX", value: "TX" },
    { label: "UT", value: "UT" },
    { label: "VT", value: "VT" },
    { label: "VA", value: "VA" },
    { label: "WA", value: "WA" },
    { label: "WV", value: "WV" },
    { label: "WI", value: "WI" },
    { label: "WY", value: "WY" },
    { label: "PR", value: "PR" },
];
